import { render, staticRenderFns } from "./SubmitalDocuments.vue?vue&type=template&id=4cb226d0&scoped=true&"
import script from "./SubmitalDocuments.vue?vue&type=script&lang=js&"
export * from "./SubmitalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalDocuments.vue?vue&type=style&index=0&id=4cb226d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb226d0",
  null
  
)

export default component.exports